import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function ChartUpIcon({ className, size = 20, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12C22 8.26154 22 6.3923 21.1962 5C20.6695 4.08788 19.9121 3.33046 19 2.80385C17.6077 2 15.7385 2 12 2C8.26154 2 6.3923 2 5 2.80385C4.08788 3.33046 3.33046 4.08788 2.80385 5C2 6.3923 2 8.26154 2 12C2 15.7385 2 17.6077 2.80385 19C3.33046 19.9121 4.08788 20.6695 5 21.1962C6.3923 22 8.26154 22 12 22C15.7385 22 17.6077 22 19 21.1962C19.9121 20.6695 20.6695 19.9121 21.1962 19C22 17.6077 22 15.7385 22 12ZM13 8.66406C12.5858 8.66406 12.25 8.99985 12.25 9.41406C12.25 9.82828 12.5858 10.1641 13 10.1641H14.0036L12 12.1676L11.0303 11.198C10.8897 11.0573 10.6989 10.9783 10.5 10.9783C10.3011 10.9783 10.1103 11.0573 9.96967 11.198L6.46967 14.698C6.17678 14.9909 6.17678 15.4657 6.46967 15.7586C6.76256 16.0515 7.23744 16.0515 7.53033 15.7586L10.5 12.789L11.4697 13.7586C11.7626 14.0515 12.2374 14.0515 12.5303 13.7586L15.0784 11.2105V12.2425C15.0784 12.6567 15.4142 12.9925 15.8284 12.9925C16.2426 12.9925 16.5784 12.6567 16.5784 12.2425V9.41406C16.5784 8.99985 16.2426 8.66406 15.8284 8.66406H13Z"
        fill="currentColor"
      />
    </svg>
  )
}
